import {
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  PLATFORM_ID,
  DOCUMENT
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastService } from './toast.service';
import { Subject, takeUntil } from 'rxjs';

declare let bootstrap: any;

@Component({
  selector: 'app-toast-page',
  templateUrl: './toast-page.component.html',
  styleUrls: ['./toast-page.component.scss'],
})
export class ToastPageComponent implements AfterViewInit {
  @ViewChild('toastContainer', { static: true }) toastContainer!: ElementRef;

  private isBrowser: boolean;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) platformId: Object,
    private toastService: ToastService
  ) {
    this.isBrowser = isPlatformBrowser(platformId); // <- garante que é client-side
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      this.toastService.registerToast(this.showToast.bind(this));
    }
  }

  showToast(title: string, message: string, type: string = 'primary'): void {
    if (!this.isBrowser) return;

    // 1) Cria o elemento do toast
    const toastEl = this.renderer.createElement('div');
    toastEl.className = `toast text-bg-${type} border-0 fade show`;
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'assertive');
    toastEl.setAttribute('aria-atomic', 'true');
    Object.assign((toastEl as HTMLElement).style, {
      borderRadius: '5px',
      marginBottom: '10px'
    });

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      (toastEl as HTMLElement).style.width = '100%';
      (toastEl as HTMLElement).style.maxWidth = '100%';
    } else {
      (toastEl as HTMLElement).style.width = '380px';
      (toastEl as HTMLElement).style.minWidth = '380px';
      (toastEl as HTMLElement).style.maxWidth = '380px';
    }

    toastEl.innerHTML = `
      <div class="toast-body fw-semibold">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"
          style="position: relative; float: right; font-size: 8pt;"></button>
        <h6 style="font-weight: bolder; font-size: 10pt; margin-bottom: 5px">${title}</h6>
        ${message}
      </div>
    `;

    // 2) Anexa ao container e instancia o Bootstrap Toast
    this.renderer.appendChild(this.toastContainer.nativeElement, toastEl);
    const toastInstance = new bootstrap.Toast(toastEl, {
      autohide: true,
      delay: 4000,
    });
    toastInstance.show();

    // 3) Swipe-to-dismiss (apenas em mobile)
    if (isMobile) {
      let startY = 0;
      let moved = false;
      const THRESHOLD = -50;

      toastEl.addEventListener('touchstart', (e: TouchEvent) => {
        startY = e.touches[0].clientY;
        moved = false;
      }, { passive: true });

      toastEl.addEventListener('touchmove', (e: TouchEvent) => {
        const deltaY = e.touches[0].clientY - startY;
        if (deltaY < 0) {
          moved = true;
          (toastEl as HTMLElement).style.transform = `translateY(${deltaY}px)`;
        }
      }, { passive: true });

      toastEl.addEventListener('touchend', (e: TouchEvent) => {
        const endY = e.changedTouches[0].clientY;
        const deltaY = endY - startY;
        if (moved && deltaY < THRESHOLD) {
          // anima pra cima e some
          (toastEl as HTMLElement).style.transform = 'translateY(-100%)';
          (toastEl as HTMLElement).style.opacity = '0';
          setTimeout(() => toastInstance.hide(), 300);
        } else {
          // retorna à posição original
          (toastEl as HTMLElement).style.transform = 'translateY(0)';
        }
      }, { passive: true });
    }

    // 4) Cleanup ao ocultar
    toastEl.addEventListener('hidden.bs.toast', () => {
      this.renderer.removeChild(this.toastContainer.nativeElement, toastEl);
    });
  }

}
